import type { $Fetch } from "ofetch";

/**
 * Nome do Controller da API
 */
const controller = "/agendamento";

/**
 * Classe de gerenciamento de chamadas da API dos Agendamnentos
 *
 * @class
 */
export default class AgendamentoApi {
    /**
     * Instância da dependência da API (ofetch)
     */
    private api;

    /**
     * Cria uma nova instância da classe AgendamentoApi.
     * @constructor
     * @param api - Instância da dependência da API (ofetch).
     */
    constructor(api: $Fetch) {
        this.api = api;
    }

    /**
   * @returns LerRegistro CID
   */
    async lerRegistro(codAgendamento: number) {
        return this.api<ApplicationModule[]>(`${controller}/lerRegistro`, {
            method: "GET",
            params: { codAgendamento }
        });
    }
}